import { Stack } from "@chakra-ui/layout";
import { forwardRef, IconProps, Text } from "@chakra-ui/react";
import React from "react";

export const MenuCard = forwardRef<IconProps, "svg">(({ icon, children, onClick, ...rest }, ref) => (
    <Stack ref={ref} h="67px" w="67px" alignItems="center" justifyContent="center" {...rest}
        onClick={() => {
            if (ga) {
                ga('send', 'event', 'Menu icon', 'click', '(' + children + ')');
            }
            onclick && onClick(icon);
        }}>
        {icon}
        <Text fontSize="10px">{children}</Text>
    </Stack>
));